// extracted by mini-css-extract-plugin
module.exports = {"option-select":"ChoiceOptions_option-select__2VAyT"};